import { Dialog, absolute } from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import { SettingsMenu } from '../SettingsMenu';
import { BaseViewModel, useViewModelConstructor } from '@/common/utils/mobx/ViewModel';
import { autorun } from 'mobx';
import { makeSimpleAutoObservable } from '@/common/utils/mobx/mobx';
import { HosterAppModel, useHosterAppModel } from '@/hoster/models/HosterAppModel';

export interface SettingsViewModelProps {
  appModel: HosterAppModel;
}

export class SettingsViewModel extends BaseViewModel<SettingsViewModelProps> {
  urlInputValue = '';

  constructor(props: SettingsViewModelProps) {
    super(props);

    autorun(() => {
      this.urlInputValue = props.appModel.devGameUrl ?? '';
    });

    makeSimpleAutoObservable(this, {}, { autoBind: true });
  }

  toggleShowSettings() {
    this.props.appModel.uiModel.toggleSettingsModal();
  }

  setUrl() {
    this.props.appModel.devGameUrl = this.urlInputValue;
  }
}

export const SettingDialog = observer(() => {
  const appModel = useHosterAppModel();

  const viewModel = useViewModelConstructor(SettingsViewModel, { appModel });

  return (
    <Dialog
      css={[absolute(0, 0, 0, 0)]}
      open={appModel.uiModel.showSettingsModal}
      onOpenChange={viewModel.toggleShowSettings}
    >
      <SettingsMenu viewModel={viewModel} />
    </Dialog>
  );
});
